<template>
  <div class="form-group lm-select" v-if="isVisible" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right mt-1"
      :class="{ 'ml-2': help }"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <font-awesome-icon
      icon="question-circle"
      size="sm"
      class="clickable float-right mt-1"
      v-if="help"
      v-b-tooltip.hover="help"
      />
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
      <select
        v-model="select"
        :class="{'is-invalid': v.$error}"
        :disabled="disabled"
        class="form-control"
        :id="idComputed"
        >
        <option v-if="options.disabledOption" disabled :value="returnObjectIdName ? null: ''">{{options.disabledOption}}</option>
        <template v-if="typeof options.content[0] !== 'object' ">
          <option v-for="(option, index) of options.content" :key="index">{{option}}</option>
        </template>
        <template v-if="typeof options.content[0] === 'object' && !returnObjectIdName">
          <option v-for="(option, index) of options.content" :key="index" :value="option.value" :disabled="option.disabled || false">{{option.text}}</option>
        </template>
        <template v-if="returnObjectIdName">
          <option v-for="(option, index) of options.content" :key="`returnObjectIdName-${index}`" :value="option.id">{{option.name}}</option>
        </template>
      </select>
      <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    /**
    * Select options
    */
    options: {
      type: Object,
      required: true
    },
    returnObjectIdName: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    select: {
      get () {
        return this.returnObjectIdName ? this.value.id || null : this.value
      },
      set (value) {
        if (Object.entries(this.v).length) {
          this.v.$touch()
        }
        if (this.returnObjectIdName) {
          const objectValuesToEmit = this.options.content.find(el => el.id === value)
          this.$emit('input', objectValuesToEmit)
        } else {
          this.$emit('input', value)
        }
      }
    }
  }
}
</script>
